import React, {Component} from 'react';
import FooterModal from "../../comum/components/FooterModal"
import { Label } from "reactstrap";
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import { IconeCarregar } from './Icones';

export default class ModalForm extends Component {

    state = {
        novoNome: ""
    }

    handleCancelar = () => { this.props.onClickCancelar(this.props.oldValue) }

    onChange = (e) => { this.setState({novoNome: e.target.value}) } 

    botaoSalvar = () => {
        return this.props.esconderSalvar ? null : 
               <Label className={`${(this.props.habilitaSalvar != undefined ? (this.props.habilitaSalvar ? "btn-primary" : "btn-disabled") : "btn-primary")} btn-modal-confirmar`} 
                      onClick={this.props.habilitaSalvar != undefined ? (this.props.habilitaSalvar ? this.props.onClickSalvar : ()=>{}) : this.props.onClickSalvar}> 
                      {this.props.labelConfirmar ? this.props.labelConfirmar : "SALVAR"}                      
                </Label>
    }

    render() {
		return (
            <ModalContainer zIndex={100} className={ this.props.classContainer ? this.props.classContainer : '' }>
                <ModalDialog className={ this.props.className ? "nosso-modal modal-margin " + this.props.className : "nosso-modal modal-margin" }>
                    <div className={!this.props.opcoesHabilitadas ? "modal-form" :""}>
                        { this.props.children }
                    </div>
                    <FooterModal>
                        <div className="justify-content-end">
                            { !this.props.salvando
                                && <Label className="btn-primary btn-modal-cancelar" onClick={ this.props.onClickCancelar }> {this.props.labelCancelar ? this.props.labelCancelar : "CANCELAR"}</Label>
                            }
                            { this.props.salvando
                                ? <IconeCarregar tamanho="2x"/>
                                : this.botaoSalvar()
                            }
                            { !this.props.salvando && this.props.onClickEnviar &&
                                <Label className={`${(this.props.habilitaSalvar != undefined ? (this.props.habilitaSalvar ? "btn-primary" : "label-disabled") : "btn-primary")}`} 
                                        onClick={ this.props.onClickEnviar }> {this.props.labelEnviar ? this.props.labelEnviar : "ENVIAR"}</Label> }
                        </div>
                    </FooterModal>
                </ModalDialog>
            </ModalContainer>
        )
	}
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/ModalForm.js